import axios from 'axios';
import store from '../../store/index';

export default {
	list() {
		return axios.get(`/api/qualifications?deleted=true`);
	},
	create(qualification) {
		return axios.post(`/api/qualifications`, { name: qualification.name, description: qualification.description });
	},
	update(qualification) {
		return axios.patch(`/api/qualifications/${qualification.id}`, {
			name: qualification.name,
			description: qualification.description,
			deleted: qualification.deleted,
		});
	},
	delete(qualificationId) {
		return axios.delete(`/api/qualifications/${qualificationId}`);
	},
};
